/* eslint-disable */ import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  height: auto;\n  justify-content: flex-start;\n  padding: 15px 40px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { isDesktop } from "react-device-detect";
import styled from "styled-components";
import Button from "../../components/Button/Button";
import Text from "../../components/Text/Text";
import MoreHorizontal from "../../components/Svg/Icons/MoreHorizontal";
import { connectorLocalStorageKey, walletConnectConfig, walletLocalStorageKey } from "./config";
var WalletButton = styled(Button).attrs({
    width: "100%",
    variant: "text",
    py: "16px"
}).withConfig({
    componentId: "sc-a58bd64b-0"
})(_templateObject());
export var MoreWalletCard = function(_param) {
    var t = _param.t, props = _object_without_properties(_param, [
        "t"
    ]);
    return /*#__PURE__*/ _jsxs(WalletButton, _object_spread_props(_object_spread({
        variant: "tertiary"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(MoreHorizontal, {
                width: "40px",
                mb: "8px",
                color: "textSubtle"
            }),
            /*#__PURE__*/ _jsx(Text, {
                fontSize: "14px",
                children: t("More")
            })
        ]
    }));
};
var WalletCard = function(param) {
    var login = param.login, walletConfig = param.walletConfig, onDismiss = param.onDismiss;
    var title = walletConfig.title, Icon = walletConfig.icon;
    return /*#__PURE__*/ _jsxs(WalletButton, {
        variant: "tertiary",
        onClick: function() {
            // TW point to WC on desktop
            // if (title === "Coinbase Wallet") {
            //   console.log("打开Coinbase");
            //   login(walletConfig.connectorId);
            //   localStorage?.setItem(walletLocalStorageKey, walletConfig.title);
            //   localStorage?.setItem(connectorLocalStorageKey, walletConfig.connectorId);
            //   onDismiss();
            //   return;
            // }
            // if (title === "TokenPocket") {
            //   console.log("打开TP");
            //   login(ConnectorNames.Injected);
            //   localStorage?.setItem(walletLocalStorageKey, 'TokenPocket');
            //   localStorage?.setItem(connectorLocalStorageKey, ConnectorNames.Injected);
            //   onDismiss();
            //   return;
            // }
            if (title === "Trust Wallet" && walletConnectConfig && isDesktop) {
                login(walletConnectConfig.connectorId);
                localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(walletLocalStorageKey, walletConnectConfig.title);
                localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(connectorLocalStorageKey, walletConnectConfig.connectorId);
                onDismiss();
                return;
            }
            if (!window.ethereum && walletConfig.href) {
                window.open(walletConfig.href, "_blank", "noopener noreferrer");
            } else {
                login(walletConfig.connectorId);
                localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(walletLocalStorageKey, walletConfig.title);
                localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(connectorLocalStorageKey, walletConfig.connectorId);
                onDismiss();
            }
        },
        id: "wallet-connect-".concat(title.toLowerCase()),
        children: [
            title === "FoxWallet" ? /*#__PURE__*/ _jsx("img", {
                src: "/images/small-img/fox.png",
                alt: "",
                style: {
                    width: "34px",
                    marginRight: "10px",
                    borderRadius: "10px"
                }
            }) : title === "Bitkeep Wallet" ? /*#__PURE__*/ _jsx("img", {
                src: "/images/small-img/bit.svg",
                alt: "",
                style: {
                    width: "32px",
                    marginRight: "12px"
                }
            }) : //   <img
            //     src="/images/wallet/bitget.png"
            //     alt=""
            //     style={{ width: "34px", marginRight: "10px", borderRadius: "10px" }}
            //   />
            // ) : title === "TokenPocket" ? (
            //   <img
            //     src="/images/wallet/tokenPocket.png"
            //     alt=""
            //     style={{ width: "34px", marginRight: "10px", borderRadius: "10px" }}
            //   />
            // ) : title === "Trust Wallet" ? (
            //   <img
            //     src="/images/wallet/trustWallet.png"
            //     alt=""
            //     style={{ width: "34px", marginRight: "10px", borderRadius: "10px" }}
            //   />
            // ) : title === "WalletConnect" ? (
            //   <img
            //     src="/images/wallet/walletConnect.png"
            //     alt=""
            //     style={{ width: "34px", marginRight: "10px", borderRadius: "10px" }}
            //   />
            // ) : (
            /*#__PURE__*/ _jsx(Icon, {
                width: "34px",
                mr: "10px"
            }),
            /*#__PURE__*/ _jsx(Text, {
                fontSize: "14px",
                children: title
            })
        ]
    });
};
export default WalletCard;
